import { uniq } from 'lodash';
import type { Criteria } from '../types';

/* eslint-disable no-console */
const CONNECT_SEARCH_CRITERIA = 'CONNECT_SEARCH_CRITERIA';

export const loadCriteria = () => {
  try {
    const serializedState = localStorage.getItem(CONNECT_SEARCH_CRITERIA);
    if (serializedState === null) return undefined;
    const { criteria } = JSON.parse(serializedState);

    return { criteria };
  } catch (e) {
    return undefined;
  }
};

export const saveCriteria = (criteria: { criteria: Criteria }) => {
  try {
    const serialState = JSON.stringify(criteria);
    localStorage.setItem(CONNECT_SEARCH_CRITERIA, serialState);
  } catch (e) {
    console.warn('ERROR SAVING CRITERIA', { e });
  }
};

const CONNECT_OFF_MARKET_SEARCH = 'CONNECT_OFF_MARKET_SEARCH';
const CONNECT_OFF_MARKET_TABLE_VIEW = 'CONNECT_OFF_MARKET_TABLE_VIEW';
const CONNECT_CALL_LIST_TABLE_VIEW_TAG = 'CONNECT_CALL_LIST_TABLE_VIEW_TAG';

export const loadOffMarketSearchFlag = () => {
  try {
    const item = localStorage.getItem(CONNECT_OFF_MARKET_SEARCH);
    if (item !== 'false') return true;

    return false;
  } catch (e) {
    return true;
  }
};

export const loadOffMarketTableViewFlag = () => {
  try {
    const item = localStorage.getItem(CONNECT_OFF_MARKET_TABLE_VIEW);
    if (item && item !== 'false') return true;

    return false;
  } catch (e) {
    return false;
  }
};

export const saveOffMarketSearchFlag = (flag: string) => {
  try {
    localStorage.setItem(CONNECT_OFF_MARKET_SEARCH, flag);
  } catch (e) {
    console.warn('ERROR SAVING OFF MARKET SEARCH FLAG', { e });
  }
};

export const updateTableViewFlag = (flag: string) => {
  try {
    localStorage.setItem(CONNECT_OFF_MARKET_TABLE_VIEW, flag);
  } catch (e) {
    console.warn('ERROR SETTING TABLE VIEW FLAG', { e });
  }
};

export const loadCallListTableViewFlag = () => {
  try {
    const item = localStorage.getItem(CONNECT_CALL_LIST_TABLE_VIEW_TAG);
    if (item && item !== 'false') return true;

    return false;
  } catch (e) {
    return false;
  }
};

export const updateCallListTableViewFlag = (flag: string) => {
  try {
    localStorage.setItem(CONNECT_CALL_LIST_TABLE_VIEW_TAG, flag);
  } catch (e) {
    console.warn('ERROR SETTING TABLE VIEW FLAG', { e });
  }
};

const corporateLlcDataStorageKey = (id: string) => `CORPORATE_LLC_DATA_${id}`;

export const loadLlcData = (propertyId: string) => {
  try {
    const data = localStorage.getItem(corporateLlcDataStorageKey(propertyId));
    if (data) return JSON.parse(data);
  } catch (e) {
    return null;
  }
};

export const saveLlcData = (propertyId: string, data) => {
  try {
    localStorage.setItem(corporateLlcDataStorageKey(propertyId), JSON.stringify(data));
  } catch (e) {
    console.warn('ERROR SAVING CORPORATE LLC DATA', { e });
  }
};

const corporateDocumentsStorageKey = (id: string) => `CORPORATE_DOCUMENTS_${id}`;

export const loadCompanyDocuments = (companyId: string) => {
  try {
    const data = localStorage.getItem(corporateDocumentsStorageKey(companyId));
    if (data) return JSON.parse(data);
  } catch (e) {
    return true;
  }
};

export const saveCompanyDocuments = (companyId: string, documents) => {
  try {
    localStorage.setItem(corporateDocumentsStorageKey(companyId), JSON.stringify(documents));
  } catch (e) {
    console.warn('ERROR SAVING COMPANY DOCUMENTS', { e });
  }
};

const RECENT_CONNECT_TAGS = 'RECENT_CONNECT_TAGS';

export const getRecentTags = () => {
  try {
    const tagString = localStorage.getItem(RECENT_CONNECT_TAGS);
    if (!tagString) return [];

    return JSON.parse(tagString) || [];
  } catch (e) {
    console.warn('ERROR FETCHING LOCALLY STORED TAGS', { e });
  }
};

export const setRecentTag = (tag: string) => {
  try {
    let recentTags = getRecentTags();
    recentTags = uniq([tag, ...recentTags]).slice(0, 4);
    localStorage.setItem(RECENT_CONNECT_TAGS, JSON.stringify(recentTags));
  } catch (e) {
    console.warn('ERROR SAVING TAGS TO LOCALSTORAGE', { e });
  }
};
/* eslint-enable no-console */
